import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mdiAccountMultiple } from "@mdi/js";
import Icon from "@mdi/react";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { teamStore } from "../../../stores/teamStore";
import { userStore } from "../../../stores/userStore";
import { sendCounterEvent } from "../../../utils/counterService";
import { getSubscriptionPlanName } from "../../../utils/subscriptionPlan";

import "./PlanBadge.css";

export const PlanBadge = observer(function PlanBadge() {
  const { t } = useTranslation();
  const subscription = userStore.subscription;
  const plan = subscription?.plan;
  if (!plan) return null;

  const label = getSubscriptionPlanName(plan);
  const isTeamMember = teamStore.isTeamMember;

  const tooltipContent = isTeamMember ? (
    <>
      {t("subscription.teamPlan")}: Premium
      <br />
      {t("subscription.yourPlan")}: {label}
    </>
  ) : (
    <>
      {t("subscription.yourPlan")}: {label}
    </>
  );

  const planLower = plan.toLowerCase();

  const badge = isTeamMember ? (
    <Link
      to="/subscription"
      className="plan-badge"
      onClick={() => sendCounterEvent("header_plan")}
    >
      <Icon
        path={mdiAccountMultiple}
        size={0.75}
        className="plan-badge__icon"
      />
      Premium
    </Link>
  ) : (
    <Link
      to="/subscription"
      className={`plan-badge plan-badge--${planLower}`}
      onClick={() => sendCounterEvent("header_plan")}
    >
      {label}
    </Link>
  );

  return <Tooltip title={tooltipContent}>{badge}</Tooltip>;
});
